"use strict";
const resolveAssetBase = () => {
    if (typeof document === 'undefined') {
        return '/';
    }
    const current = document.currentScript;
    const scriptSrc = (current && current.src) ||
        Array.from(document.scripts)
            .map((script) => script.src)
            .find((src) => /\/[^/]+\/app\.js(\?.*)?$/.test(src));
    if (!scriptSrc) {
        return '/';
    }
    return scriptSrc.replace(/\/[^/]+\/app\.js(\?.*)?$/, '/');
};
__webpack_public_path__ = resolveAssetBase();
